// @mui
import { TableHeadProps } from './interface';

// ----------------------------------------------------------------------

export default function UserListHead({ columns }: TableHeadProps) {
  return (
    <thead>
      <tr>
        {columns?.map(({ dataIndex, title, width, align = 'center' }) => (
          <th key={dataIndex} style={{ width }} align={align}>
            {title}
          </th>
        ))}
      </tr>
    </thead>
  );
}
